<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y v-if="user.roleName != 'PRODUCTION_MANAGER'">
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
      
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field name="name" label="Bin Name" type="text" v-model="queryParams.name"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="binList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.name }}</td>
              <td v-if="props.item.warehouse">{{ props.item.warehouse.name }}</td>
              <td v-else></td>
              <td>{{ props.item.binType.typeName }}</td>
              <td>{{ props.item.maxCapacity }}</td>
              <td>{{ props.item.minCapacity}}</td>
              <td>{{ props.item.stockBalance}}</td>
              <td>{{ props.item.selfExpireInMilliSeconds | format-ms-date-time}}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { binService } from "../../services/bin-service";
import { warehouseService } from "../../services/warehouse-service";
export default {
  name: "BinList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Bin",
        disabled: true
      }
    ],
    headers: [
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false },
      { text: "Name", align: "left", value: "name" },
      { text: "Warehouse", align: "left", value: "warehouse.name" },
      { text: "Bintype", value: "binType.typeName" },
      { text: "MaxCapacity", value: "maxCapacity" },
      { text: "MinCapacity", value: "minCapacity" },
      { text: "StockBalance", value: "stockBalance" },
      { text: "SelfExpire", value: "selfExpire" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    binList: [],
    warehouseList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      status: "ACTIVE",
      warehouseId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getBinList();
        this.getWarehouseList();
      },
      deep: true
    }
  },

  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.user.roleName == "BRANCH_ADMIN") {
      this.queryParams.warehouseId = this.user.warehouseId;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "bins", query: this.queryParams });
      this.getBinList();
    },
    getBinList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      binService
        .getBinList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.binList = res.data.binList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },
    onRegister() {
      this.$router.push("/bin/new");
    },
    onEdit(bin) {
      // go to details page
      this.$router.push("/bin/" + bin.id);
    }
  }
};
</script>

